import {
  BecomeDealerStepper,
  Collaboration,
  DealerFAQs,
  JoinNetwork,
} from "@/components/BecomeDealer";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container } from "@mui/material";

const BecomeDealer = () => {
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <JoinNetwork />
      <Collaboration />
      <BecomeDealerStepper />
      <DealerFAQs />
    </>
  );
};

export default BecomeDealer;
